import {
  AftersalesOrder,
  AftersalesOrderItem,
} from '@1po/1po-bff-fe-spec/generated/aftersales_order/model/AftersalesOrder';
import {
  ASC,
  ASC_EXADIS,
  ClaimFormGroupType,
  ClaimFormType,
  DIRECT_DELIVERY,
  FULL_OTC,
  MULTI_ITEMS_DIRECT_DELIVERY,
  MULTI_ITEMS_FULL_OTC,
} from 'domains/order/Order.types';

const ORDER_PLANT_DIRECT_DERIVERY = 'FRDD';
const ORDER_PLANT_BATTERY = 'FR05';
export const EXADIS_SUPPLIER_CODE = '0041006400';

export const getOrderMarkMaxLength = (userCountry: string | undefined): number => {
  switch (userCountry) {
    case 'ES':
      return 17;
    case 'IT':
      return 7;
    default:
      return 40;
  }
};

export const getFormGroupType = (formType: ClaimFormType): ClaimFormGroupType => {
  switch (formType) {
    case DIRECT_DELIVERY:
      return DIRECT_DELIVERY;
    case ASC:
    case ASC_EXADIS:
    case FULL_OTC:
      return FULL_OTC;
    case MULTI_ITEMS_DIRECT_DELIVERY:
      return MULTI_ITEMS_DIRECT_DELIVERY;
    case MULTI_ITEMS_FULL_OTC:
      return MULTI_ITEMS_FULL_OTC;
    default:
      return undefined;
  }
};

export const isExadisOrderItem = (orderItem: AftersalesOrderItem): boolean => {
  return orderItem.purchaseOrder?.supplier === EXADIS_SUPPLIER_CODE;
};

export const getClaimFormType = (salesOrderLinePlant: string | undefined, isExadis: boolean): ClaimFormType => {
  if (salesOrderLinePlant === ORDER_PLANT_DIRECT_DERIVERY) {
    return DIRECT_DELIVERY;
  }
  return isExadis ? ASC_EXADIS : ASC;
};

export const getMultiItemsFormType = (
  order: AftersalesOrder,
): typeof MULTI_ITEMS_DIRECT_DELIVERY | typeof MULTI_ITEMS_FULL_OTC | undefined => {
  const orderItems = order.items ?? [];
  if (orderItems.length === 0) {
    return undefined;
  }
  if (orderItems.every((item) => item.salesOrderLinePlant === ORDER_PLANT_DIRECT_DERIVERY)) {
    return MULTI_ITEMS_DIRECT_DELIVERY;
  }
  if (
    orderItems.some(
      (item) =>
        !item.salesOrderLinePlant ||
        item.salesOrderLinePlant === ORDER_PLANT_BATTERY ||
        item.salesOrderLinePlant === ORDER_PLANT_DIRECT_DERIVERY,
    )
  ) {
    return undefined;
  }
  return MULTI_ITEMS_FULL_OTC;
};

export const normalizeOptionalString = (value: string | undefined): string | undefined => {
  if (value === undefined) {
    return undefined;
  }

  const normalizedValue = value.trim();
  return normalizedValue === '' ? undefined : normalizedValue;
};
